<template>
<div id="">
  <v-container fluid class="pt-0">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">

          <v-card-title class="secondary white--text">
            <v-icon class="mr-2" small :color="contest.status===0 ? 'blue' : contest.status===1 ? 'green' : contest.status===2 ? 'red' : 'grey' " dark>fa-circle</v-icon> {{contest.title ? contest.title : `${contest.brand_name} ${contest.prize}`}}
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
            <v-btn icon dark @click="$router.go(-1)" exact>
              <v-icon>fa-times</v-icon>
            </v-btn>
            <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="primary"></v-progress-linear>
          </v-card-title>

          <v-container class="">
            <v-row>
              <v-col cols="12" lg="6">
                <div class="">
                  <v-card>
                    <v-card-title class="secondary white--text">
                      Details
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="show_details=!show_details">
                        <v-icon v-if="show_details">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show_details">
                        <v-container class="pt-4">
                          <v-row justify="center">

                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Contest by" v-model="contest.brand_name"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Talk about" v-model="contest.talk_about"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Prize" v-model="contest.prize"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field outlined hide-details type="number" label="Minumum runner ups" v-model="contest.min_runner_ups"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field outlined hide-details type="number" label="Project Bonus" v-model="contest.project_bonus"></v-text-field>
                            </v-col>
                            <v-col cols="12" class="text-center pt-4">
                              <v-slider label="Minimum rank" v-model="contest.min_rank" :min="1" :max="10" thumb-label="always" class="mt-4"></v-slider>
                            </v-col>
                            <v-col cols="12">
                              <v-menu ref="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                                <template v-slot:activator="{ on }">
                                        <v-text-field
                                          :value="$helpers.date(contest.deadline)"
                                          label="Deadline"
                                          prepend-icon="fa-calendar"
                                          readonly
                                          v-on="on"
                                          clearable
                                          @click:clear="contest.deadline = null"
                                        ></v-text-field>
                                      </template>
                                <v-date-picker v-model="contest.deadline" no-title>

                                </v-date-picker>
                              </v-menu>
                            </v-col>

                            <v-col cols="12">
                              <v-textarea outlined hide-details label="Challenge" v-model="contest.notes"></v-textarea>
                            </v-col>

                            <v-col cols="12" lg="12" xl="10" class="text-center">
                              <image-picker :tile="true" title="Prize image" color="cool_purple" :size="300" v-model="contest.prize_image"></image-picker>
                            </v-col>
                          </v-row>

                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-card>

                  <v-card class="mt-4">
                    <v-card-title class="secondary white--text">
                      Clickthrough Gradients
                      <v-spacer></v-spacer>

                    </v-card-title>

                    <v-card tile>
                      <v-card-title :style="gradientStyle(contest.gradients.contest_by.color_1,contest.gradients.contest_by.color_2)" class="white--text">
                        Contest by
                      </v-card-title>
                      <v-card-text class="pt-4 text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn :color="contest.gradients.contest_by.color_1" dark v-on="on">Color 1</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.contest_by.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="ml-4" :color="contest.gradients.contest_by.color_2" dark v-on="on">Color 2</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.contest_by.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>

                    <v-card tile>
                      <v-card-title :style="gradientStyle(contest.gradients.talk_about.color_1,contest.gradients.talk_about.color_2)" class="white--text">
                        Talk about
                      </v-card-title>
                      <v-card-text class="pt-4 text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn :color="contest.gradients.talk_about.color_1" dark v-on="on">Color 1</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.talk_about.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="ml-4" :color="contest.gradients.talk_about.color_2" dark v-on="on">Color 2</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.talk_about.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>

                    <v-card tile>
                      <v-card-title :style="gradientStyle(contest.gradients.challenge.color_1,contest.gradients.challenge.color_2)" class="white--text">
                        Challenge
                      </v-card-title>
                      <v-card-text class="pt-4 text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn :color="contest.gradients.challenge.color_1" dark v-on="on">Color 1</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.challenge.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="ml-4" :color="contest.gradients.challenge.color_2" dark v-on="on">Color 2</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.challenge.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>


                    <v-card tile>
                      <v-card-title :style="gradientStyle(contest.gradients.rank_requirement.color_1,contest.gradients.rank_requirement.color_2)" class="white--text">
                        Rank requirement
                      </v-card-title>
                      <v-card-text class="pt-4 text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn :color="contest.gradients.rank_requirement.color_1" dark v-on="on">Color 1</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.rank_requirement.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="ml-4" :color="contest.gradients.rank_requirement.color_2" dark v-on="on">Color 2</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.rank_requirement.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>

                    <v-card tile>
                      <v-card-title :style="gradientStyle(contest.gradients.deadline.color_1,contest.gradients.deadline.color_2)" class="white--text">
                        Closing date
                      </v-card-title>
                      <v-card-text class="pt-4 text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn :color="contest.gradients.deadline.color_1" dark v-on="on">Color 1</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.deadline.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="ml-4" :color="contest.gradients.deadline.color_2" dark v-on="on">Color 2</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.deadline.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>

                    <v-card tile>
                      <v-card-title :style="gradientStyle(contest.gradients.bonus.color_1,contest.gradients.bonus.color_2)" class="white--text">
                        Bonus
                      </v-card-title>
                      <v-card-text class="pt-4 text-center">
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn :color="contest.gradients.bonus.color_1" dark v-on="on">Color 1</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.bonus.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on }">
                            <v-btn class="ml-4" :color="contest.gradients.bonus.color_2" dark v-on="on">Color 2</v-btn>
                          </template>
                          <v-color-picker v-model="contest.gradients.bonus.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                        </v-menu>
                      </v-card-text>
                    </v-card>

                  </v-card>


                </div>
                <div class="pt-4" v-if="projectsList.length">
                  <v-card>
                    <v-card-title class="secondary white--text">
                      Eligible Entries
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="show_publications=!show_publications">
                        <v-icon v-if="show_publications">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>

                      <div v-show="show_publications">
                        <v-container fluid style="max-height:600px;overflow-y:auto">
                          <v-row justify="center">

                            <v-col cols="12" v-for="(project,i) in projectsList" :key="i">

                              <v-card>
                                <v-card-title v-if="contest.runner_ups.includes(project.id)" :class="`${contest.winner===project.id ? 'cool_purple' : 'green'} white--text`">
                                  <span v-if="contest.winner===project.id">Winner</span>
                                  <span v-else>Runner Up</span>
                                  <v-spacer></v-spacer>

                                  <v-chip dark v-if="contest.winner===project.id" close @click:close="contest.winner=null" color="cool_purple">

                                  </v-chip>


                                  <v-chip v-if="!contest.winner && contest.winner!==project.id" color="cool_purple" @click="contest.winner=project.id" close outlined dark close-icon="fa fa-gift">
                                    Select Winner
                                  </v-chip>



                                </v-card-title>


                                <v-container>
                                  <v-row align="center">

                                    <v-col cols="4">
                                      <router-link :to="`/admin/projects/${project.id}`" class="nolink">
                                        <img :src="project.thumbnail" style="width:100%;height:auto" />
                                      </router-link>
                                    </v-col>
                                    <v-col cols="8">
                                      <div class="">
                                        <router-link :to="`/admin/projects/${project.id}`" class="nolink">{{project.title}}</router-link>
                                      </div>
                                      <v-btn x-large v-if="project.url" :href="project.url" target="_blank" icon>
                                        <v-icon x-large :color="$helpers.linkColor(project.url)">{{$helpers.linkIcon(project.url)}}</v-icon>
                                      </v-btn>
                                      <v-btn x-large v-if="project.igtv_url" :href="project.igtv_url" target="_blank" icon>
                                        <v-icon x-large :color="$helpers.linkColor(project.igtv_url)">{{$helpers.linkIcon(project.igtv_url)}}</v-icon>
                                      </v-btn>
                                      <v-btn x-large v-if="project.facebook_url" :href="project.facebook_url" target="_blank" icon>
                                        <v-icon x-large :color="$helpers.linkColor(project.facebook_url)">{{$helpers.linkIcon(project.facebook_url)}}</v-icon>
                                      </v-btn>
                                      <v-btn x-large v-if="project.linkedin_url" :href="project.linkedin_url" target="_blank" icon>
                                        <v-icon x-large :color="$helpers.linkColor(project.linkedin_url)">{{$helpers.linkIcon(project.linkedin_url)}}</v-icon>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-container>

                                <v-card-actions class="grey lighten-3 py-0">

                                  <v-spacer></v-spacer>
                                  <v-checkbox dense @change="resetWinner" label="Runner up" color="primary" :value="project.id" v-model="contest.runner_ups"></v-checkbox>

                                </v-card-actions>
                              </v-card>

                            </v-col>

                          </v-row>

                        </v-container>
                      </div>

                    </v-expand-transition>
                  </v-card>
                </div>
              </v-col>


              <v-col cols="12" lg="6">

                <div>
                  <v-card>
                    <v-card-title class="secondary white--text">
                      Banner
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="show_banner=!show_banner">
                        <v-icon v-if="show_banner">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show_banner">
                        <v-container class="pt-4">
                          <v-row justify="center" align="center">
                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Slug" v-model="contest.slug"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Title" v-model="contest.title" @change="generateSlug"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea outlined hide-details label="Description" v-model="contest.description"></v-textarea>
                            </v-col>

                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Title Mobile" v-model="contest.title_mobile"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                              <v-textarea outlined hide-details label="Description Mobile" v-model="contest.description_mobile"></v-textarea>
                            </v-col>
                            <v-col cols="12" xl="6">
                              <v-card>
                                <v-card-title :style="gradientStyle(contest.color_1,contest.color_2)" class="white--text">
                                  Gradient
                                </v-card-title>
                                <v-card-text class="pt-4 text-center">

                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on }">
                                      <v-btn :color="contest.color_1" dark v-on="on">Color 1</v-btn>
                                    </template>
                                    <v-color-picker v-model="contest.color_1" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                                  </v-menu>
                                  <v-menu offset-y>
                                    <template v-slot:activator="{ on }">
                                      <v-btn class="ml-4" :color="contest.color_2" dark v-on="on">Color 2</v-btn>
                                    </template>
                                    <v-color-picker v-model="contest.color_2" show-swatches :hide-mode-switch="true" mode="hex"></v-color-picker>
                                  </v-menu>
                                </v-card-text>
                              </v-card>
                            </v-col>
                            <v-col cols="12" xl="6" class="text-center">
                              <image-picker :tile="true" title="Brand logo" :size="100" v-model="contest.brand_logo"></image-picker>
                            </v-col>
                          </v-row>

                        </v-container>
                      </div>
                    </v-expand-transition>





                  </v-card>
                </div>

                <div class="pt-4">
                  <v-card>
                    <v-card-title class="secondary white--text">
                      Promo material
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="show_promo=!show_promo">
                        <v-icon v-if="show_promo">fa-minus</v-icon>
                        <v-icon v-else>fa-chevron-down</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-expand-transition>
                      <div v-show="show_promo">
                        <v-container class="pt-4">
                          <v-row justify="center">
                            <v-col cols="12" xl="10">
                              <image-picker title="Poster" :size="350" :tile="true" v-model="contest.promo_poster"></image-picker>
                            </v-col>
                            <v-col cols="12">
                              <v-text-field outlined hide-details label="Video" v-model="contest.promo_video_url"></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </div>
                    </v-expand-transition>
                  </v-card>
                </div>


              </v-col>



            </v-row>


          </v-container>

          <v-card-actions class="grey lighten-3" style="min-height:50px" v-if="modified">
            <v-spacer></v-spacer>
            <v-btn color="green" dark v-if="modified" id="save-btn" @click="save" :loading="loading">Save</v-btn>
          </v-card-actions>
          <v-card-actions class="grey lighten-3" style="min-height:50px" v-else-if="openRequirement">
            <v-spacer></v-spacer>
            <h5 class="error--text"><v-icon class="mr-2">fa-exclamation-triangle</v-icon>{{openRequirement}}</h5>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-card-actions class="grey lighten-3" style="min-height:50px" v-else>
            <v-spacer></v-spacer>
            <v-btn color="green" dark @click="openContest" :loading="loading" v-if="contest.status===0 || contest.status===2 || contest.status===3">Open contest</v-btn>
            <v-btn color="red" dark @click="closeContest" :loading="loading" v-if="contest.status===1">Close contest</v-btn>
            <v-btn color="blue" dark @click="completeContest" :loading="loading" v-if="contest.status===2">Contest completed</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>

        </v-card>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import imagePicker from "@/components/app/image-picker-2";


let generate_slug = function(v) {
  let slug = '';
  v.trim().toLowerCase().split("").forEach(p => {
    if (p === " ") {
      slug = slug + "-"
    }
    if (alphabet.concat(numbers).includes(p)) {
      slug = slug + p
    }
  })
  return slug;
}

let alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"]
let numbers = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"]


export default {
  name: "",
  components: {
    imagePicker: imagePicker
  },
  data: () => ({
    requirement: null,
    show_details: true,
    show_promo: true,
    show_banner: true,
    show_publications: true,
    contest: {},
    projects: [],
    loading: false,
    modified: false
  }),
  created() {
    this.load()
  },
  watch: {
    'contest': {
      handler: function(to, from) {
        if (to.id && from.id) {
          this.modified = true
        }
      },
      deep: true
    }
  },
  computed: {
    openRequirement() {
      if (!this.contest.title) {
        return "Title required"
      }
      if (!this.contest.brand_logo) {
        return "Brand logo required"
      }
      if (!this.contest.slug) {
        return "Slug required"
      }
      if (!this.contest.promo_poster) {
        return 'Promo poster required'
      }
      if (!this.contest.promo_video_url) {
        return 'Promo video required'
      }
      return false
    },
    projectsList() {
      return this.projects.filter(function(project) {
        return [11, 3].includes(project.status) && project.contest_id === this.contest.id
      }.bind(this))
    }
  },
  methods: {
    generateSlug() {
      this.contest.slug = generate_slug(this.contest.title)
    },
    resetWinner() {
      if (!this.contest.runner_ups.includes(this.contest.winner)) {
        this.contest.winner = null
      }
    },
    async openContest() {


      this.contest.status = 1;
      this.save()
    },
    async closeContest() {

      if (this.contest.runner_ups.length < parseInt(this.contest.min_runner_ups)) {
        return alert(`Contest only has ${this.contest.runner_ups.length}/${this.contest.min_runner_ups} runner ups.`)
      }


      this.contest.status = 2;
      this.save()
    },
    async completeContest() {
      if (!this.contest.winner) {
        return alert("Winner required")
      }
      this.contest.status = 3;
      this.save()
    },
    gradientStyle(color_1, color_2) {
      return `background: ${color_1};background: -webkit-linear-gradient(to right, ${color_1}, ${color_2});background: linear-gradient(to right, ${color_1}, ${color_2});`
    },
    async load() {
      this.loading = true
      this.contest = await this.$api(`/account/admin/contests/${this.$route.params.id}`)
      this.projects = await this.$api(`/account/admin/projects?contest_id=${this.contest.id}`)
      setTimeout(function() {
        this.modified = false
      }.bind(this), 100)
      this.loading = false
    },
    async save() {
      this.loading = true
      try {
        this.contest = await this.$api({
          method: "POST",
          url: `/account/admin/contests/${this.$route.params.id}`,
          data: this.contest
        })
        setTimeout(function() {
          this.modified = false
        }.bind(this), 100)
      } catch (ex) {
        alert(ex.error)
      }
      this.loading = false
    },
    scrollToSave() {
      setTimeout(function() {
        this.$vuetify.goTo("#save-btn", {
          duration: 300,
          offset: 100,
          easing: "easeInOutCubic",
        })
      }.bind(this), 100)
    },
  },
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        this.scrollToSave()
        next(false)
      }
    } else {
      next()
    }
  },
}
</script>
<style lang="scss" scoped>
</style>
